import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import { STORAGE } from '@/constants/storage.constants';

const ifAuthenticated = (to, from, next) => {
  localStorage.setItem(STORAGE.PAGE_URL, to.path);

  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

const isFirstAccess = (to, from, next) => {
  if (store.state.auth.firstAccess) next();
  else next('/');
};

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'error',
    component: () => import('@/pages/ErrorPage.vue'),
  },
  {
    path: '/first-access',
    component: () => import('@/layouts/NoPointsLayout.vue'),
    children: [
      {
        path: '',
        name: 'site.first-access',
        beforeEnter: isFirstAccess,
        component: () => import('@/pages/FirstAccessPage.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/layouts/SiteLayout.vue'),
    children: [
      {
        path: '',
        name: 'site.index',
        component: () => import('@/pages/LandingPage.vue'),
      },
      {
        path: 'my-info',
        name: 'site.my-info',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/MyInfoPage.vue'),
      },
      {
        path: 'club',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/Club/ClubPagesContainer.vue'),
        children: [
          {
            path: 'info',
            alias: '',
            name: 'club.index',
            component: () => import('@/pages/Club/ClubPage.vue'),
          },
          {
            path: 'regulation',
            name: 'club.regulation',
            component: () => import('@/pages/Club/RegulationPage.vue'),
          },
          {
            path: 'informatives',
            name: 'club.informatives',
            component: () => import('@/pages/Club/InformativesPage.vue'),
          },
          {
            path: 'informatives/:id',
            name: 'club.informatives.view',
            component: () => import('@/pages/Club/InformativeViewPage.vue'),
          },
        ],
      },
      {
        path: 'ranking',
        name: 'site.ranking',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/RankingPage.vue'),
      },
      {
        path: 'my-sales',
        name: 'site.my-sales',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/MySalesPage.vue'),
      },
      {
        path: 'trainings',
        name: 'site.trainings',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/Trainings/TrainingsPage.vue'),
      },
      {
        path: 'trainings/:id',
        name: 'site.trainings.view',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/Trainings/TrainingsViewPage.vue'),
      },
      {
        path: 'trainings/:id/answer',
        name: 'site.trainings.answer',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/Trainings/TrainingsAnsweringPage.vue'),
      },
      {
        path: 'points',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/Points/PointsPagesContainer.vue'),
        children: [
          {
            path: 'info',
            alias: '',
            name: 'points.index',
            component: () => import('@/pages/Points/PointsTablePage.vue'),
          },
          {
            path: 'campaigns',
            name: 'points.campaigns',
            component: () => import('@/pages/Points/CampaignsPage.vue'),
          },
          {
            path: 'campaigns/:id',
            name: 'points.campaigns.view',
            component: () => import('@/pages/Points/CampaignViewPage.vue'),
          },
          {
            path: 'extract',
            name: 'points.extract',
            component: () => import('@/pages/Points/PointsExtractPage.vue'),
          },
        ],
      },
      {
        path: 'points-exchange/redeem',
        name: 'site.points-exchange.redeem',
        beforeEnter: ifAuthenticated,
        component: () =>
          import('@/pages/PointsExchange/PointsExchangeRedeemPage.vue'),
      },
      {
        path: 'points-exchange/mapipay',
        name: 'site.points-exchange.mapipay',
        beforeEnter: ifAuthenticated,
        component: () =>
          import('@/pages/PointsExchange/PointsExchangeMapiPayPage.vue'),
      },
      {
        path: 'points-exchange/trade',
        name: 'site.points-exchange.trade',
        beforeEnter: ifAuthenticated,
        component: () =>
          import('@/pages/PointsExchange/PointsExchangeTradePage.vue'),
      },
      {
        path: 'points-exchange',
        name: 'site.points-exchange',
        beforeEnter: ifAuthenticated,
        component: () =>
          import('@/pages/PointsExchange/PointsExchangePage.vue'),
      },
      {
        path: 'request-card',
        name: 'site.request-card',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/RequestCardDuplicatePage.vue'),
      },
      {
        path: 'contact',
        name: 'site.contact',
        beforeEnter: ifAuthenticated,
        component: () => import('@/pages/ContactPage.vue'),
      },
      {
        path: 'reset-password/:uuid',
        name: 'site.reset-password',
        component: () => import('@/pages/ResetPasswordPage.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
